// 事件名称常量
export const eventNameConstants = {
    ON_LOGIN: "onLogin",
    ON_LOGOUT: "onLogout",
    ON_JOIN_ROOM: "onJoinRoom",
    ON_LEAVE_ROOM: "onLeaveRoom",
    ON_PUBLISH_MEDIA: "onPublishMedia",
    ON_CANCEL_PUBLISH_MEDIA: "onCancelPublishMedia",
    ON_PAUSE_PUBLISH_MEDIA: "onPausePublishMedia",
    ON_RESUME_PUBLISH_MEDIA: "onResumePublishMedia",
    ON_RECEIVE_MESSAGE: "onReceiveMessage",
    ON_RECEIVE_ROOM_MESSAGE: "onReceiveRoomMessage",
    ON_INVITE: "onInvite",
    ON_INVITE_ANSWER: "onInviteAnswer",
    ON_MEDIA_END: "onMediaEnd",
    ON_DISCONNECT: "onDisconnect",
    ON_PUBLISH_DATA: "onPublishData"
};
// sessionStorage key常量
export const jyxRtcConstants = {
    JYX_RTC_LOGIN_OPTIONS: "jyxRtcLoginOptions",
    JYX_RTC_JOIN_ROOM_OPTIONS: "jyxRtcJoinRoomOptions",
    JYX_RTC_ROOM_ID: "jyxRtcRoomId",
    JYX_RTC_ROOM_PASSWORD: "jyxRtcRoomPassword",
    JYX_RTC_BEFORE_PAGE_NAME: "jyxRtcBeforePageName",
    JYX_RTC_CURRENT_PAGE_NAME: "jyxRtcCurrentPageName",
    JYX_RTC_RELOGIN: "jyxRtcRelogin",
    JYX_RTC_UNLOAD_PAGE_NAME: "jyxRtcUnloadPageName"
};

// 媒体流类型常量
export const mediaTypeConstants = {
    AUDIO: "audio",
    VIDEO: "video",
    SCREEN_AUDIO: "screen_audio",
    SCREEN_VIDEO: "screen_video",
    EXTERNAL_AUDIO: "external_audio",
    EXTERNAL_VIDEO: "external_video"
};

// 录制类型常量
export const recordTypeConstants = {
    AUDIO: "audio",
    VIDEO: "video",
    STREAM: "stream"
};
